import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Select } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { PassengerSelectionComponent } from '../../_components/passenger-selection/passenger-selection.component';
import { Router } from '@angular/router';
import { ShipDropdown } from '../../_models';
import { Constants } from '../../_utility';
import { Passenger } from '../../_models/Passenger';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';
import { ApiService, AuthService } from '../../_services';
import { SpinnerService } from '../../_components/spinner/spinner.service';

@Component({
  selector: 'app-third-part-reservation',
  templateUrl: './third-part-reservation.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [Select, ButtonModule, PassengerSelectionComponent, ReactiveFormsModule, TranslateModule],
})
export class ThirdPartReservationComponent implements OnInit {
  selectedShip!: any;
  cabinNumber?: number;
  ships: ShipDropdown[] = [];
  public passengerList: Passenger[] = [];
  form: FormGroup;
  selectedPassenger: Passenger | undefined;
  cabins: string[] = [];
  loaded = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private breadcrumb: BreadcrumbsService,
    private auth: AuthService,
    private apiService: ApiService,
    private spinner: SpinnerService
  ) {
    this.form = this.fb.group({
      ship: ['', [Validators.required]],
      cabinNumber: [{ value: '', disabled: true }, [Validators.required]],
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.ADMINISTRATION.path);
    }, 200);
    const currentUser = this.auth.getCurrentUser();
    if (currentUser) {
      // Get user's ships from local storage
      const userDataStr = localStorage.getItem('currentUser');
      if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        if (userData.ships && userData.ships.length > 0) {
          // Transform ships data to match the format needed by the dropdown
          this.ships = userData.ships.map((ship: any) => ({
            name: ship,
            code: ship,
          }));
        }
      }
    }
  }
  onShipChange(event: any) {
    this.form.get('cabinNumber')?.enable();
    this.getCabins();
  }

  getCabins() {
    this.spinner.show();
    this.apiService.Cabins(this.form.value.ship.code).subscribe({
      next: (response) => {
        this.cabins = response;
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error fetching cabins:', error);
        this.spinner.hide();
      },
    });
  }

  onSubmit(): void {
    this.spinner.show();
    this.apiService
      .Passengers(this.form.value.cabinNumber, this.form.value.ship.code)
      .subscribe({
        next: (response) => {
          this.passengerList = response;
          this.loaded = true;
          this.spinner.hide();
        },
        error: (error) => {
          console.error('Error fetching passengers:', error);
          this.spinner.hide();
        },
      });
  }

  onPassengersSelected(selectedPassengers: Passenger[]): void {
    this.selectedPassenger = selectedPassengers[0];
  }

  ConfirmSelection() {
    this.router.navigate(Constants.Routing.ADMINISTRATION_TABLE.routerLink, {
      queryParams: { passengerId: this.selectedPassenger?.uuid_passenger },
    });
  }
  Back() {
    this.goTo('booking_management');
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'booking_management': {
        this.router.navigate(Constants.Routing.HOME_PRENOTAZIONI.routerLink);
        break;
      }
    }
  }
}
